import type NotificationEntities from '../../../contracts/NotificationEntities';
import { AsyncState } from '../../../store/types';

export type NotificationsLoadState = AsyncState & {
  hasFetched: boolean;
};

export type SoftpullConsentState = {
  error: Record<string, unknown>;
  hasFetched: boolean;
  isLoading: boolean;
  isOptedIn: boolean;
};

export type NotificationSettingsState = {
  entities: NotificationEntities | null;
  notifications: NotificationsLoadState;
  softpullConsent: SoftpullConsentState;
  updateEmailNotifications: AsyncState;
  updateTCPANotifications: AsyncState;
};

const FETCH_NOTIFICATIONS_BEGIN = 'account/NotificationSettings/FETCH_NOTIFICATIONS_BEGIN';
const FETCH_NOTIFICATIONS_SUCCESS = 'account/NotificationSettings/FETCH_NOTIFICATIONS_SUCCESS';
const FETCH_NOTIFICATIONS_FAILURE = 'account/NotificationSettings/FETCH_NOTIFICATIONS_FAILURE';

const FETCH_SOFTPULL_CONSENT_BEGIN = 'account/NotificationSettings/FETCH_SOFTPULL_CONSENT_BEGIN';
const FETCH_SOFTPULL_CONSENT_SUCCESS =
  'account/NotificationSettings/FETCH_SOFTPULL_CONSENT_SUCCESS';
const FETCH_SOFTPULL_CONSENT_FAILURE =
  'account/NotificationSettings/FETCH_SOFTPULL_CONSENT_FAILURE';

const UPDATE_EMAIL_NOTIFICATIONS_BEGIN =
  'account/NotificationSettings/UPDATE_EMAIL_NOTIFICATIONS_BEGIN';
const UPDATE_EMAIL_NOTIFICATIONS_SUCCESS =
  'account/NotificationSettings/UPDATE_EMAIL_NOTIFICATIONS_SUCCESS';
const UPDATE_EMAIL_NOTIFICATIONS_FAILURE =
  'account/NotificationSettings/UPDATE_EMAIL_NOTIFICATIONS_FAILURE';

const UPDATE_TCPA_NOTIFICATIONS_BEGIN =
  'account/NotificationSettings/UPDATE_TCPA_NOTIFICATIONS_BEGIN';
const UPDATE_TCPA_NOTIFICATIONS_SUCCESS =
  'account/NotificationSettings/UPDATE_TCPA_NOTIFICATIONS_SUCCESS';
const UPDATE_TCPA_NOTIFICATIONS_FAILURE =
  'account/NotificationSettings/UPDATE_TCPA_NOTIFICATIONS_FAILURE';

const UPDATE_CREDIT_MONITORING_CONSENT_BEGIN =
  'account/NotificationSettings/UPDATE_CREDIT_MONITORING_CONSENT_BEGIN';
const UPDATE_CREDIT_MONITORING_CONSENT_SUCCESS =
  'account/NotificationSettings/UPDATE_CREDIT_MONITORING_CONSENT_SUCCESS';
const UPDATE_CREDIT_MONITORING_CONSENT_FAILURE =
  'account/NotificationSettings/UPDATE_CREDIT_MONITORING_CONSENT_FAILURE';

export {
  FETCH_NOTIFICATIONS_BEGIN,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_SOFTPULL_CONSENT_BEGIN,
  FETCH_SOFTPULL_CONSENT_SUCCESS,
  FETCH_SOFTPULL_CONSENT_FAILURE,
  UPDATE_EMAIL_NOTIFICATIONS_BEGIN,
  UPDATE_EMAIL_NOTIFICATIONS_SUCCESS,
  UPDATE_EMAIL_NOTIFICATIONS_FAILURE,
  UPDATE_TCPA_NOTIFICATIONS_BEGIN,
  UPDATE_TCPA_NOTIFICATIONS_SUCCESS,
  UPDATE_TCPA_NOTIFICATIONS_FAILURE,
  UPDATE_CREDIT_MONITORING_CONSENT_BEGIN,
  UPDATE_CREDIT_MONITORING_CONSENT_SUCCESS,
  UPDATE_CREDIT_MONITORING_CONSENT_FAILURE
};
